/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'
import type { Exact } from '@modules/ts-essentials'

import type { components, operations } from './types'

// GET /api/v1/serverless/projects/elasticsearch
// ts-unused-exports:disable-next-line
export const listElasticsearchProjects = async (args?: {
  queryParameters?: operations['listElasticsearchProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProjectList']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/projects/elasticsearch
// ts-unused-exports:disable-next-line
export const createElasticsearchProject = async <
  T = operations['createElasticsearchProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createElasticsearchProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createElasticsearchProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createElasticsearchProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProjectCreated']>(
    '/api/v1/serverless/projects/elasticsearch',
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const getElasticsearchProject = async (args: {
  pathParameters: operations['getElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProject']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const patchElasticsearchProject = async <
  T = operations['patchElasticsearchProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchElasticsearchProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchElasticsearchProject']['parameters']['path']
  body: Exact<
    T,
    operations['patchElasticsearchProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchElasticsearchProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProject']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const deleteElasticsearchProject = async (args: {
  pathParameters: operations['deleteElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/elasticsearch/{id}', args), {
    method: 'DELETE',
  })

// POST /api/v1/serverless/projects/elasticsearch/{id}/_reset-credentials
// ts-unused-exports:disable-next-line
export const resetElasticsearchProjectCredentials = async (args: {
  pathParameters: operations['resetElasticsearchProjectCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/_reset-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/elasticsearch/{id}/_reset-internal-credentials
// ts-unused-exports:disable-next-line
export const resetElasticsearchProjectInternalCredentials = async (args: {
  pathParameters: operations['resetElasticsearchProjectInternalCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters(
      '/api/v1/serverless/projects/elasticsearch/{id}/_reset-internal-credentials',
      args,
    ),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/elasticsearch/{id}/_resume
// ts-unused-exports:disable-next-line
export const resumeElasticsearchProject = async (args: {
  pathParameters: operations['resumeElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/_resume', args),
    {
      method: 'POST',
    },
  )

// GET /api/v1/serverless/projects/elasticsearch/{id}/roles
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectRoles = async (args: {
  pathParameters: operations['getElasticsearchProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/elasticsearch/{id}/status
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectStatus = async (args: {
  pathParameters: operations['getElasticsearchProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/observability
// ts-unused-exports:disable-next-line
export const listObservabilityProjects = async (args?: {
  queryParameters?: operations['listObservabilityProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['ObservabilityProjectList']>(
    applyParameters('/api/v1/serverless/projects/observability', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/projects/observability
// ts-unused-exports:disable-next-line
export const createObservabilityProject = async <
  T = operations['createObservabilityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createObservabilityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createObservabilityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createObservabilityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ObservabilityProjectCreated']>(
    '/api/v1/serverless/projects/observability',
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const getObservabilityProject = async (args: {
  pathParameters: operations['getObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ObservabilityProject']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const patchObservabilityProject = async <
  T = operations['patchObservabilityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchObservabilityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchObservabilityProject']['parameters']['path']
  body: Exact<
    T,
    operations['patchObservabilityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchObservabilityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ObservabilityProject']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const deleteObservabilityProject = async (args: {
  pathParameters: operations['deleteObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/observability/{id}', args), {
    method: 'DELETE',
  })

// POST /api/v1/serverless/projects/observability/{id}/_reset-credentials
// ts-unused-exports:disable-next-line
export const resetObservabilityProjectCredentials = async (args: {
  pathParameters: operations['resetObservabilityProjectCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/_reset-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/observability/{id}/_reset-internal-credentials
// ts-unused-exports:disable-next-line
export const resetObservabilityProjectInternalCredentials = async (args: {
  pathParameters: operations['resetObservabilityProjectInternalCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters(
      '/api/v1/serverless/projects/observability/{id}/_reset-internal-credentials',
      args,
    ),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/observability/{id}/_resume
// ts-unused-exports:disable-next-line
export const resumeObservabilityProject = async (args: {
  pathParameters: operations['resumeObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/_resume', args),
    {
      method: 'POST',
    },
  )

// GET /api/v1/serverless/projects/observability/{id}/roles
// ts-unused-exports:disable-next-line
export const getObservabilityProjectRoles = async (args: {
  pathParameters: operations['getObservabilityProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/observability/{id}/status
// ts-unused-exports:disable-next-line
export const getObservabilityProjectStatus = async (args: {
  pathParameters: operations['getObservabilityProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/security
// ts-unused-exports:disable-next-line
export const listSecurityProjects = async (args?: {
  queryParameters?: operations['listSecurityProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['SecurityProjectList']>(
    applyParameters('/api/v1/serverless/projects/security', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/projects/security
// ts-unused-exports:disable-next-line
export const createSecurityProject = async <
  T = operations['createSecurityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createSecurityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createSecurityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createSecurityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['SecurityProjectCreated']>(
    '/api/v1/serverless/projects/security',
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const getSecurityProject = async (args: {
  pathParameters: operations['getSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['SecurityProject']>(
    applyParameters('/api/v1/serverless/projects/security/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const patchSecurityProject = async <
  T = operations['patchSecurityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchSecurityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchSecurityProject']['parameters']['path']
  body: Exact<
    T,
    operations['patchSecurityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchSecurityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['SecurityProject']>(
    applyParameters('/api/v1/serverless/projects/security/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const deleteSecurityProject = async (args: {
  pathParameters: operations['deleteSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/security/{id}', args), {
    method: 'DELETE',
  })

// POST /api/v1/serverless/projects/security/{id}/_reset-credentials
// ts-unused-exports:disable-next-line
export const resetSecurityProjectCredentials = async (args: {
  pathParameters: operations['resetSecurityProjectCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/_reset-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/security/{id}/_reset-internal-credentials
// ts-unused-exports:disable-next-line
export const resetSecurityProjectInternalCredentials = async (args: {
  pathParameters: operations['resetSecurityProjectInternalCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/_reset-internal-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/security/{id}/_resume
// ts-unused-exports:disable-next-line
export const resumeSecurityProject = async (args: {
  pathParameters: operations['resumeSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/security/{id}/_resume', args), {
    method: 'POST',
  })

// GET /api/v1/serverless/projects/security/{id}/roles
// ts-unused-exports:disable-next-line
export const getSecurityProjectRoles = async (args: {
  pathParameters: operations['getSecurityProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/security/{id}/status
// ts-unused-exports:disable-next-line
export const getSecurityProjectStatus = async (args: {
  pathParameters: operations['getSecurityProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/status', args),
    {
      method: 'GET',
    },
  )
